import ZipUploader from "./components/ZipTreePreview";
import "./App.css";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="app-root">
      <Toaster
        position="top-right"
        theme="dark"
        richColors
        closeButton
      />
      <ZipUploader />

      {/* Footer Ad – appears after everything */}
      <footer className="app-footer-ad hide-this">
        <div className="ad-placeholder">
          Advertisement
        </div>
      </footer>
    </div>
  );
}

export default App;